import React, { createContext, useContext, useEffect } from 'react';
import {auth} from './firebase';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendPasswordResetEmail, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';

export const FormContext = createContext({
	globalForm: {},
	setGlobalForm: () => {},
});

const AuthContext = createContext()


export function useAuth() {
	return useContext(AuthContext);
}

export function AuthProvider({children}) {
	const [currentUser, setCurrentUser] = React.useState();

	async function signup(email, password) {
		return await createUserWithEmailAndPassword(auth, email, password)
	}

	async function login(email, password) {
		const ret = await signInWithEmailAndPassword(auth, email, password);
		return ret;
	}

	async function signInWithGoogle() {
		const provider = new GoogleAuthProvider();
		const ret = await signInWithPopup(auth, provider);
		return ret;
	}

	async function logout() {
		return signOut(auth);
	}

	async function resetPassword(email) {
		return sendPasswordResetEmail(auth, email);
	}


	//We only this want run once
	useEffect ( () => {
		const unsubscribe = auth.onAuthStateChanged( user => {
			setCurrentUser(user);
		} )
		return unsubscribe;
	} , [])


	const value = {
		currentUser,
		signup,	
		login,
		signInWithGoogle,
		logout,
		resetPassword,
	}

	return (
	<AuthContext.Provider value={value}>
		{children}
	</ AuthContext.Provider>

	)
}
